import { render, staticRenderFns } from "./HowToApply.vue?vue&type=template&id=b709014e&scoped=true"
import script from "./HowToApply.vue?vue&type=script&lang=js"
export * from "./HowToApply.vue?vue&type=script&lang=js"
import style0 from "./HowToApply.vue?vue&type=style&index=0&id=b709014e&prod&lang=scss&scoped=true"
import style1 from "./HowToApply.vue?vue&type=style&index=1&id=b709014e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b709014e",
  null
  
)

export default component.exports